const galleryItems = [...document.querySelectorAll('.gallery > img')];

galleryItems.forEach((el) => {
    el.addEventListener('click', () => {
        const currentActiveItem = galleryItems
            .find((item) => item.classList.contains('active'));

        if (currentActiveItem != null) {
            currentActiveItem.classList.remove('active');
        }

        el.classList.add('active');
    })
});

if (galleryItems.length > 0) {
    setInterval(() => {
        const lastIndex = Math.max(0, galleryItems.length - 1);
        const currentIndex = galleryItems.findIndex((item) => item.classList.contains('active'));
        const nextIndex = currentIndex + 1 > lastIndex ? 0 : currentIndex + 1;

        galleryItems[currentIndex].classList.remove('active');
        galleryItems[nextIndex].classList.add('active');
    }, 3e3);
}